import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ReactNode, useEffect, useState } from 'react';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Close the mobile menu whenever the route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    navigate("https://qbdconnect.com");
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
      <span>
        <header id="masthead" className="site-header header-main-layout-1 ast-primary-menu-enabled ast-logo-title-inline ast-hide-custom-menu-mobile ast-builder-menu-toggle-icon ast-mobile-header-inline">
          <div id="ast-desktop-header" className="ast-main-header-wrap main-header-bar-wrap ast-primary-header-bar ast-primary-header main-header-bar site-header-focus-item">
            <div className="ast-main-header-wrap main-header-bar-wrap ">
              <div className="ast-primary-header-bar ast-primary-header main-header-bar site-header-focus-item" data-section="section-primary-header-builder">
                <div className="site-primary-header-wrap ast-builder-grid-row-container site-header-focus-item ast-container" data-section="section-primary-header-builder">
                  <div className="ast-builder-grid-row ast-builder-grid-row-has-sides ast-builder-grid-row-no-center">
                    <div className="site-header-primary-section-left site-header-section ast-flex site-header-section-left">
                      <div className="ast-builder-layout-element ast-flex site-header-focus-item" data-section="title_tagline">
                        <div className="site-branding ast-site-identity">
                          <span className="site-logo-img">
                            <a href="https://qbdconnect.com/" className="custom-logo-link" rel="home">
                              <img width="200" height="44" src="https://qbdconnect.com/wp-content/uploads/2026/03/cropped-logo-transparent-large-white-and-green.png" className="custom-logo" alt="QBD Connect" decoding="async" /></a>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="site-header-primary-section-right site-header-section ast-flex ast-grid-right-section">
                      <div className="ast-builder-menu-1 ast-builder-menu ast-flex ast-builder-menu-1-focus-item ast-builder-layout-element site-header-focus-item" data-section="section-hb-menu-1">
                        <div className="ast-main-header-bar-alignment">
                          <div className="main-header-bar-navigation">
                            <nav className="site-navigation ast-flex-grow-1 navigation-accessibility site-header-focus-item" id="primary-site-navigation-desktop" aria-label="Primary Site Navigation">
                              {isAuthenticated && (
                                <button
                                  onClick={() => setMobileMenuOpen((open) => !open)}
                                  className={`nav-hamburger ${mobileMenuOpen ? 'is-active' : ''}`}
                                  aria-label="Toggle menu"
                                  aria-expanded={mobileMenuOpen}
                                >
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </button>
                              )}
                              {isAuthenticated && (
                                <div className={`main-navigation ast-inline-flex ${mobileMenuOpen ? 'is-open' : ''}`}>
                                  <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>Dashboard</Link>
                                  <Link to="/instances" className={`nav-link ${isActive('/instances') ? 'active' : ''}`}>Instances</Link>
                                  <Link to="/billing" className={`nav-link ${isActive('/billing') ? 'active' : ''}`}>Billing</Link>
                                  <a href="https://workhorseintegrations.atlassian.net/servicedesk/customer/portal/4" className="nav-link" target="_blank" rel="noopener noreferrer">Support</a>
                                  <Link to="/profile" className={`nav-link ${isActive('/profile') ? 'active' : ''}`}>Profile</Link>
                                  <div className="nav-divider"></div>
                                  <div className="user-menu">
                                    <span className="user-name">{user?.alias || user?.firstName || user?.username}</span>
                                    <button onClick={handleLogout} className="btn btn-primary">Logout</button>
                                  </div>
                                </div>
                              )}
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section className="hero">
          <div className="hero-bg-art">
            <div className="orb orb-1"></div>
            <div className="orb orb-2"></div>
            <div className="orb orb-3"></div>
          </div>
          <div className="hero-grid"></div>
          <div className="hero-content">
            {children}
          </div>
        </section>
        <footer className="footer">
          <script data-jsd-embedded data-key="9c425bd7-9911-4114-a881-fc16f35105c7"
              data-base-url="https://jsd-widget.atlassian.com"
              src="https://jsd-widget.atlassian.com/assets/embed.js">
          </script>
          <p>&copy; 2026 Work Horse Integrations, LLC. All rights reserved.</p>
        </footer>
      </span>
  );
};
